import cloneDeep from 'lodash.clonedeep';
import { CollectionFunctionInterfaceFormData } from 'data/collectionFunction/collectionFunction.types';

// eslint-disable-next-line import/prefer-default-export
export function handleInterfacesMdfNodeNameFieldUpdate(
  interfaceFormDataList: CollectionFunctionInterfaceFormData[] | undefined,
  fieldName: 'mdf2NodeName' | 'mdf3NodeName',
  value: string,
): CollectionFunctionInterfaceFormData[] | undefined {
  const clonedInterfaceFormDataList = cloneDeep(interfaceFormDataList);

  return clonedInterfaceFormDataList?.map((collectionFunctionInterface) => {
    collectionFunctionInterface[fieldName] = value;
    return collectionFunctionInterface;
  });
}
